module.exports = __webpack_public_path__ + "img/perfil.7e908075.svg";